export default __webpack_public_path__ + "static/media/335.505d5497.jpg";